import TextInputModal from "./TextInputModal";

export default TextInputModal;
export type { TextInputModalProps } from "./TextInputModal";
